import { useEffect, useState } from "react";
import { Loader2, Newspaper } from "lucide-react";
import { getJson } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { NewsCard, useNewsSaved } from "@/components/news/NewsCard";

export default function News() {
  const { t } = useLang();
  const [items, setItems] = useState(null);
  const { saved, toggle } = useNewsSaved();
  useEffect(() => {
    getJson("/news").then((d) => setItems(Array.isArray(d) ? d : []));
  }, []);
  const [first, ...rest] = items ?? [];
  return (
    <main className="px-5 pb-28 pt-32 md:px-10" data-testid="news-page">
      <div className="mx-auto max-w-6xl">
        <p className="mono text-[11px] uppercase tracking-[0.22em] text-[var(--muted)]">{t("nav.news")}</p>
        <h1 className="font-display mt-4 text-5xl leading-[0.95] sm:text-6xl lg:text-7xl">{t("news.l1")} <em>{t("news.l2")}</em></h1>
        <p className="mt-6 max-w-2xl text-sm text-[var(--muted)] md:text-base">{t("news.intro")}</p>
        {items === null && <Loader2 className="mx-auto mt-16 animate-spin" />}
        {items?.length === 0 && (
          <div className="invite-arch mx-auto mt-14 max-w-3xl" data-testid="news-empty">
            <Newspaper className="mx-auto text-[var(--green)]" size={30} />
            <p className="font-display mt-5 text-3xl">{t("news.empty")}</p>
          </div>
        )}
        {first && (
          <div className="mt-14 space-y-6" data-testid="news-list">
            <NewsCard n={first} featured saved={saved.includes(first.id)} onSave={toggle} />
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {rest.map((n) => <NewsCard key={n.id} n={n} saved={saved.includes(n.id)} onSave={toggle} />)}
            </div>
          </div>
        )}
        <p className="mono mt-14 text-[11px] text-[var(--muted)]" data-testid="news-disclaimer">{t("news.disclaimer")}</p>
      </div>
    </main>
  );
}
